<template>
  <DialogVue :label="'匯出寄件清單'" :show="true" @close="$emit('close')" :width="500">
    <div :style="{padding: '40px 80px', gap: '20px', display:'flex', flexDirection:'column'}">
      <!-- <div>
        <div :style="{marginBottom: '5px'}">溫層</div>
        <Select1 :width="'300px'" :defaultValue="level" @input="level=$event" :textCenter="true">
          <option v-for="(cate, c) in levels" :key="`levels-${c}`" :value="cate">{{cate}}</option>
        </Select1>
      </div>
      <div>
        <div :style="{marginBottom: '5px'}">包裹內容(10字以內)</div>
        <Input :defaultValue="Content" @input="Content=$event" :center="true"/>
      </div>
      <div>
        <div :style="{marginBottom: '5px'}">品名類別</div>
        <Select1 :width="'300px'" :defaultValue="Category" @input="Category=$event" :textCenter="true">
          <option v-for="(cate, c) in categories" :key="`cate-${c}`" :value="cate">{{cate}}</option>
        </Select1>
      </div> -->
      <div :style="{marginBottom: '5px', fontSize: '20px'}">出貨日</div>
      <DateInput :defaultValue="today" @input="today=$event"/>
      <BtnsS :style="{marginTop: '20px'}" :save="'匯出'" @cancel="$emit('close')" @save="exportFileCat"></BtnsS>
    </div>
  </DialogVue>
</template>

<script>
import DateInput from '../../components/input/date.vue'
// import Input from '../../components/input/normal.vue'
import DialogVue from '../../components/dialognoPadding2.vue'
import XLSX from 'xlsx'
export default {
  props: ['rows', 'range'],
  components: { DialogVue, DateInput },
  data () {
    return {
      today: this.moment().format('YYYY/MM/DD'),
      level: '冷凍',
      Content: '冷凍年菜',
      Category: '一般食品',
      levels: ['常溫', '冷藏', '冷凍'],
      categories: ['一般食品', '名特產/甜點', '酒/油/醋/醬', '穀物蔬果', '水產/肉品', '3C', '家電', '服飾配件', '生活用品', '美容彩妝', '保健食品', '醫療相關用品', '寵物用品飼料', '印刷品', '其他']
    }
  },
  methods: {
    getExDataCat ({ orderer, ordererTel, address, recipient, recipientTel, serialNo }, level, Content, Category) {
      const mobile = [].concat(...Array.from((recipientTel || ordererTel || '').matchAll(/\d+/ig)).map(e => Array.from(e))).join('')
      const formatMobile = mobile // .slice(0, 4) + '-' + mobile.slice(4, 10)
      return {
        收件人姓名: recipient || orderer,
        收件人電話: /^09/i.test(mobile) ? '' : (recipientTel || ordererTel),
        收件人手機: /^09/i.test(mobile) ? formatMobile : '',
        收件人地址: address,
        代收金額或到付: '',
        件數: '',
        品名: '',
        備註: '',
        訂單編號: `A${serialNo.toString().padStart(5, '0')}`,
        希望配達時間: '',
        出貨日期: this.today || this.moment().format('YYYY/MM/DD'),
        預定配達日期: '',
        溫層: '',
        尺寸: '',
        寄件人: '松柏軒餐廳',
        寄件人電話: '048221199',
        寄件人手機: '',
        寄件人地址: '彰化縣永靖鄉中山路二段86號',
        保值金額: '',
        品名說明: '',
        是否列印: '',
        是否捐贈: '',
        手機載具: '',
        愛心碼: '',
        可刷卡: '',
        手機支付: ''
      }
    },
    exportFileCat () {
      const { level, Content, Category } = this.$data
      const data = JSON.parse(JSON.stringify(this.rows))
      const json = data.filter(e => e.status !== '已取消' && e.type === '宅配').map(e => this.getExDataCat(e, level, Content, Category))
      const worksheet = XLSX.utils.json_to_sheet(json)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '託運資料')
      const name = this.range.duration ? `${this.range.start}_${this.range.end}_託運資料` : `${this.range.start}_託運資料`
      XLSX.writeFile(workbook, `${name}.xlsx`)
      this.$emit('close')
    }
  }

}
</script>

<style lang="scss" scoped>

</style>
